export default __webpack_public_path__ + "static/media/gallery11.08810459.webp";